import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/mdh/Nav";
import SecurityPanel from "@/components/settings/SecurityPanel";

export default function Security() {
    return (
        <div data-testid="security-page" className="relative min-h-screen">
            <div
                className="bg-grid-slate pointer-events-none absolute inset-0 opacity-40"
                aria-hidden="true"
            />
            <header className="relative mx-auto flex h-16 max-w-5xl items-center justify-between px-5 lg:px-8">
                <Logo />
                <Link
                    to="/dashboard"
                    data-testid="security-back-link"
                    className="flex items-center gap-1.5 font-mono text-[11px] text-slate-500 hover:text-cyan-300"
                >
                    <ArrowLeft className="h-3 w-3" /> Dashboard
                </Link>
            </header>

            <div className="relative mx-auto max-w-3xl px-5 pb-24 pt-10 lg:px-8">
                <h1 className="font-hero text-3xl font-bold tracking-tight text-slate-100 sm:text-4xl">
                    Security
                </h1>
                <p className="mt-2 text-sm text-slate-400">
                    Where your account is signed in, and what happened recently.
                </p>
                <div className="mt-8">
                    <SecurityPanel />
                </div>
            </div>
        </div>
    );
}
